import IAddressDto from '../../../../../../ShakhsSales/SakhsSalesBimehNameh/Commands/Soddor/IAddressDto';

const AddressInitialState: IAddressDto = {
  codePosti: '',
  mobile: '',
  tel: '',
  neshani: '',
  cityCoreId: '',
  email: '',
};

export default AddressInitialState;
